import { useLayoutEffect } from 'react';
import useIsMobile from 'hooks/useIsMobile';

/**
 * Scrolls the page back to the top, imperatively.
 *
 * Exported separately from the hook because callers outside a render — the
 * dashboard tour's exit path, which leaves the page parked on whichever section
 * it last spotlighted — need the behaviour without a dependency to key it on.
 *
 * The two breakpoints have different scrollers: on desktop the real one is the
 * inner `<main>` (`components/Layout/Layout.module.scss` — `.contentWrapper` /
 * `.content` are `overflow-y: auto` inside a height-bounded container), while on
 * tablet and below those release their overflow and the window scrolls.
 */
export function scrollToTop(isMobile: boolean) {
  const scrollElement = isMobile
    ? window
    : document.getElementsByTagName('main')[0];
  if (scrollElement) {
    scrollElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }
}

function useScrollToTop(dependency: unknown) {
  const isMobile = useIsMobile();

  useLayoutEffect(() => {
    scrollToTop(isMobile);
  }, [dependency, isMobile]);
}

export default useScrollToTop;
